import { createFileRoute } from '@tanstack/react-router';
import FailedExportsPage from '@features/admin/orders/FailedExportsPage';

export const Route = createFileRoute('/admin/order-exports/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <FailedExportsPage />;
}
